export const referenceTags = {
  agency: 'agency',
  boss: 'boss',
  client: 'client',
  colleague: 'colleague',
  cofounder: 'cofounder',
  partner: 'partner',
  pupil: 'pupil',
  startups: 'startups',
};

export default referenceTags;
